
/**
* @constructor
* Implements a minimal form validation
*
* @param {Element} form The form element.
* @param {string} type - global error message or individual error message (unique|multiple)
*/
export default function FormValidate(form, type = 'unique') {

	const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

	const passwordRegex = /^(?=.*\d)(?=.*\W)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,32}$/;

	const postalCodeRegex = /^(?:0[1-9]|00[1-9]|[1-9]{2}|[1-9]0)\d{2,3}$/;

	const telRegex = /^[+]?[\s/0-9]{10,17}$/;

	const blackList = document.querySelector('.bl').innerText.split(',');

	this.validationType = type;
	this.form = form;
	this.form.noValidate = true;
	this.globalMessage = '';
	this.globalErrorElt = this.form.querySelector('.formErrorMessage');
	this.nbError = 0;
	this.submitButton = this.form.querySelector('input[type=submit]');

	this.emailErrorMessage = (this.form.querySelector('.message-email')) ? this.form.querySelector('.message-email').innerHTML : "";
	this.phoneErrorMessage = (this.form.querySelector('.message-phone')) ? this.form.querySelector('.message-phone').innerHTML : "";
	this.postalCodeErrorMessage = (this.form.querySelector('.message-postalCode')) ? this.form.querySelector('.message-postalCode').innerHTML : "";
	this.requiredErrorMessage = "Veuillez renseigner ce champ.";
	this.mdpConfirmErrorMessage = (this.form.querySelector('.message-mdpConfirm')) ? this.form.querySelector('.message-mdpConfirm').innerHTML : "";

	const emailBlackListErrorMessage = (this.form.querySelector('.message-blackList')) ? this.form.querySelector('.message-blackList').innerHTML : "";

	// form submit event
	this.form.addEventListener('submit', (e) => this.validateForm(e));

	this.validateForm = (e) => {

		// prevent submit
		e.preventDefault();
		e.stopImmediatePropagation();

		if (this.submitButton.classList.contains('loading')) return;

		// prevent new submit
		this.submitButton.classList.add('loading');

		const fields = Array.from(this.form.elements);

		// Reset
		this.reset(fields);
		this.nbError = 0;

		this.addSrLoading();


		if (this.form.checkValidity()) {



			let isOk = true;

			// Check if check different that navigator default
			fields.forEach((f) => {
				if (f.getAttribute('type') === 'email') {

					if (!this.validateEmail(f)) {
						isOk = false;
						this.unvalidateField(f);
						this.nbError += 1;
					}

				}

				if (f.getAttribute('type') === 'tel') {

					const tel_corrected = f.value.replace(/([-.()])*/g, '');
					f.value = tel_corrected;

					// check if at least 10 numbers
					if (f.value.match(/\d/g) < 10 || f.value.match(/\d/g).length > 17) {
						isOk = false;
						f.setCustomValidity(this.phoneErrorMessage);
						this.unvalidateField(f);
						this.nbError += 1;
					}

					if (!telRegex.test(f.value)) {
						isOk = false;
						f.setCustomValidity(this.phoneErrorMessage);
						this.unvalidateField(f);
						this.nbError += 1;
					}

				}

				if (f.dataset.type === "password") {
					if (!this.validatePassword(f)) {
						isOk = false;
						this.unvalidateField(f);
						this.nbError += 1;
					}
				}

				if (f.dataset.type === "password-confirm") {
					if (f.value !== form.querySelector('.js-base-mdp').value) {

						isOk = false;
						f.setCustomValidity(this.mdpConfirmErrorMessage);
						this.unvalidateField(f);
						this.nbError += 1;
					}
				}

			});

			// Form valid, trigger event
			if (isOk) {
				this.form.dispatchEvent(new Event('validated'));
			} else {
				this.validityResults();
			}

		} else {


			// Check fields
			fields.forEach((f) => {
				if (f.getAttribute('type') !== 'submit' && f.getAttribute('type') !== 'hidden') {

					let isOk = true;

					if (f.validity.valueMissing) {

						isOk = false;
						f.setCustomValidity(this.requiredErrorMessage);

					} else {

						const tel_corrected = f.value.replace(/([-.()])*/g, '');

						switch (f.getAttribute('type')) {
							case 'email':
								if (!this.validateEmail(f)) {
									isOk = false;
								}
								break;

							case 'tel':

								f.value = tel_corrected;

								// check if at least 10 numbers
								if (f.value.match(/\d/g).length < 10 || f.value.match(/\d/g).length > 17) {
									isOk = false;
									f.setCustomValidity(this.phoneErrorMessage);

								}

								if (!telRegex.test(f.value)) {
									isOk = false;
									f.setCustomValidity(this.phoneErrorMessage);
								}
								break;

							default:

								switch (f.dataset.type) {
									case 'password':
										if (!this.validatePassword(f)) {
											isOk = false;
										}
										break;
									case 'password-confirm':
										if (f.value !== form.querySelector('.js-base-mdp').value) {
											f.setCustomValidity(this.mdpConfirmErrorMessage);
											isOk = false;
										}
										break;
									case 'postal_code':
										if (!this.validatePostalCode(f)) {
											isOk = false;
										}
										break;

									default:
										if (!f.checkValidity()) {
											isOk = false;
										}
										break;
								}
						}

					}

					if (!isOk) {
						this.unvalidateField(f);
						this.nbError += 1;
					} else {
						this.validateField(f);
					}

				}
			});

			this.validityResults();

		}
	};



	this.validateEmail = (field) => {

		if (field.validity.valueMissing) {
			field.setCustomValidity(this.requiredErrorMessage);
			return false;
		}

		if (!emailRegex.test(field.value)) {
			field.setCustomValidity(this.emailErrorMessage);
			return false;
		}

		// Check black List
		if (document.querySelector('.bl')) {
			if (blackList.includes(field.value.split("@").pop())) {
				field.setCustomValidity(emailBlackListErrorMessage);
				return false;
			}
		}

		return true;
	};


	this.validatePostalCode = (field) => {


		if (field.validity.valueMissing) {
			field.setCustomValidity(this.requiredErrorMessage);

			return false;
		}

		if (field.validity.tooShort) {

			return false;
		}

		if (field.validity.tooLong) {

			return false;
		}

		if (!postalCodeRegex.test(field.value)) {
			field.setCustomValidity(this.postalCodeErrorMessage);

			return false;
		}

		return true;

	};



	this.validatePassword = (field) => {


		if (field.validity.valueMissing) {
			field.setCustomValidity(this.requiredErrorMessage);
			return false;
		}

		let passOk = true;
		let mess = "<div>Le mot de passe doit contenir au moins : <ul>";

		if (field.validity.tooShort) {
			mess += "<li>8 caractères</li> ";
			passOk = false;
		}

		if (field.validity.tooLong) {
			mess += "<li>moins de 32 caractères</li> ";
			passOk = false;
		}

		if (!passwordRegex.test(field.value)) {

			if (!field.value.match(/[a-z]/g)) {
				mess += "<li>une lettre minuscule</li> ";
			}

			if (!field.value.match(/[A-Z]/g)) {
				mess += "<li>une lettre majuscule</li> ";
			}

			if (!field.value.match(/[0-9]/g)) {
				mess += "<li>un chiffre</li> ";
			}

			if (!field.value.match(/[?=.*\W]/g)) {
				mess += "<li>un caractère spécial</li> ";
			}

			mess += "</ul></div>";
			passOk = false;
		}

		if (!passOk) {
			field.setCustomValidity(mess);
			return false;
		}

		return true;

	};


	this.validityResults = () => {
		if (this.validationType === 'unique') {
			// show error message
			this.showGlobal();
		} else if (this.validationType === 'mono-field') {
			this.showMonoError();
		} else {
			// show message only for screen reader
			this.showMultiple();
		}

		this.submitButton.classList.remove('loading');
	};

	this.reset = (fields) => {
		this.globalMessage = '<ol>';
		this.globalErrorElt.innerHTML = '';
		this.form.querySelector('.formResultMessage').innerHTML = '';

		fields.forEach((f) => {
			if (f.getAttribute('type') !== 'submit' && f.getAttribute('type') !== 'hidden') {
				this.validateField(f);
			}
		});
	};

	this.validateField = (f) => {
		f.setCustomValidity('');
		f.setAttribute('aria-invalid', false);
		if (f.parentElement.querySelector('.indiError')) {
			f.parentElement.querySelector('.indiError').remove();
		}

		if ((f.dataset.type == "password" || f.dataset.type == "password-confirm") && f.parentElement.parentElement.querySelector('.indiError')) {
			f.parentElement.parentElement.querySelector('.indiError').remove();
		}

		if (f.classList.contains('toggle__input') && f.parentElement.parentElement.parentElement.querySelector('.indiError')) {
			f.parentElement.parentElement.parentElement.querySelector('.indiError').remove();
		}

	};

	this.unvalidateField = (f) => {
		f.setAttribute('aria-invalid', true);

		if (this.validationType === 'unique') {
			this.addErrorToField(f, 'screen-reader-text');
			this.addErrorToGlobal(f);
		} else {
			this.addErrorToField(f);
			this.addErrorToGlobal(f);
		}

	};

	this.getErrorMessage = (f) => {
		let em = f.validationMessage;
		return em;
	};

	this.getErrorsTitle = () => {
		let title = "Le formulaire comporte des erreurs";

		if (this.nbError > 0) {
			title = `Le formulaire comporte ${this.nbError} erreurs`;
		}
		return title;
	}

	this.addErrorToGlobal = (f) => {
		const message = `<li><a href='#${f.getAttribute('id')}'>${f.getAttribute('data-name')} : ${this.getErrorMessage(f)}</a></li>`;
		this.globalMessage = `${this.globalMessage} ${message}`;
	};

	this.addErrorToField = (f, c = '') => {
		let parent = f.parentElement;

		if (f.dataset.type === "password" || f.dataset.type == "password-confirm" || f.tagName == "SELECT") {
			parent = f.parentElement.parentElement;
		}

		if (f.classList.contains('toggle__input')) {
			parent = f.parentElement.parentElement.parentElement;
		}

		const errorId = `error_${f.getAttribute('name')}`;
		const errorBlock = document.createElement('div');
		errorBlock.id = errorId;
		errorBlock.className = `indiError ${c}`;
		if (f.getAttribute('data-name')) {
			errorBlock.innerHTML = `${f.getAttribute('data-name')} : ${this.getErrorMessage(f)}`;
		} else {
			errorBlock.innerHTML = `${this.getErrorMessage(f)}`;
		}

		let oldDescribed = f.getAttribute('aria-describedby');
		f.setAttribute('aria-describedby', `${errorId} ${oldDescribed}`);

		parent.appendChild(errorBlock);

	};


	this.showGlobal = () => {
		this.deleteSrLoading();

		this.globalMessage = `<h3 id='error-title'>${this.getErrorsTitle()}</h3>${this.globalMessage}</ol>`;
		const er = document.createElement('div');
		er.className = 'alert alert--error';
		er.innerHTML = this.globalMessage;
		this.globalErrorElt.appendChild(er);
		this.globalErrorElt.focus();
	};

	this.showMultiple = () => {
		this.deleteSrLoading();

		const er = document.createElement('div');
		er.className = 'alert alert--error';
		er.innerHTML = `<h3 id='error-title' tabindex=-1 >${this.getErrorsTitle()}</h3>${this.globalMessage}</ol>`;

		// this.globalErrorElt.appendChild(er);
		// this.globalErrorElt.setAttribute('aria-labelledby', 'error-title');
		// document.getElementById('error-title').focus();

		this.form.querySelector('.form__status').appendChild(er);

		//focus sur le premier input faux
		const firstInvalidField = this.form.querySelector(':invalid');
		if (firstInvalidField) {
			firstInvalidField.focus();
		}

	};

	this.showMonoError = () => {
		this.deleteSrLoading();

		//focus sur le premier input faux
		const firstInvalidField = this.form.querySelector(':invalid');
		if (firstInvalidField) {
			firstInvalidField.focus();
		}
	}

	this.addSrLoading = () => {
		const ms = this.form.querySelector('.form__status');
		ms.innerHTML = 'En cours de traitement';
	};

	this.deleteSrLoading = () => {
		this.globalErrorElt.innerHTML = '';

		const ms = this.form.querySelector('.form__status');
		ms.innerHTML = '';
	};
}
